
export const AktenSelectCase = () => {
    return null
}